import React from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import NoRecord from "../components/other/NoRecord";
import { pipTimeView, pipViewDate2 } from "../utils/pip";
import { rejectUser, verifiedUser } from "../redux/action/userAction";
import { pageRoutes } from "../routes/pageRoutes";
import Loader from "../components/other/Loader";

const VerificationRequest = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch()
  const { isToggle } = useSelector((state) => state.authReducer);
  const { isLoading } = useSelector((state) => state.userReducer);
  const { value } = location.state;

  const handleVerifedUser = () => {
    const data = {
      user_id: value?.id
    }
    const callback = (response) => {
      if (response.success) navigate(pageRoutes?.verifications);
    };
    dispatch(verifiedUser({ payload: data, callback }));
  };

  const handleRejectUser = () => {
    const data = {
      user_id: value?.id
    }
    const callback = (response) => {
      if (response.success) navigate(pageRoutes?.verifications);
    };
    dispatch(rejectUser({ payload: data, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div className="ct_right_content">
          <Header />
          <div className="ct_inner_dashbaord_main">
            <div className="row ">
              <div className="col-xxl-12 col-xl-12 mb-4 mb-xl-0 ">
                {/* <h3 className="ct_fs_22 ct_ff_roboto mb-4 ct_fw_600 ">Dashboard</h3> */}
                <div className="ct_top_sticky">
                  <div className="">
                    <div className="row mt-4">
                      <div className="col-lg-8 mx-auto">
                        <div className="ct_verify_user_card py-5">
                          <div className="d-flex align-items-center gap-3 justify-content-start ct_flex_column_767 pb-4">
                            <ul className="d-flex align-items-center  gap-3 mb-0">
                              <li>
                                <a
                                  href="javascript:void(0)"
                                  onClick={() => navigate(-1)}
                                  className="text-dark"
                                >
                                  <i className="fa-solid fa-chevron-left ct_fw_600 ct_fs_20"></i>
                                </a>
                              </li>
                              <li>
                                {" "}
                                <h4 className="ct_fs_24 ct_ff_roboto ct_fw_600 mb-0 text-center">
                                  Verification Request
                                </h4>
                              </li>
                            </ul>
                          </div>

                          {value && value != 0 ? (
                            <>
                              <figure>
                                <div className="ct_verify_user_main_img">
                                  <div
                                    className="position-relative mx-auto"
                                    style={{ maxWidth: "300px" }}
                                  >
                                    <img
                                      src={
                                        value?.verification_image ??
                                        "/user_profile.png"
                                      }
                                      alt=""
                                    />
                                    <div className="ct_verification_request_view_btn_top ct_text_op_8">
                                      <a
                                        className="ct_orange_btn ct_btn_h_44 w-100 d-flex  align-items-center justify-content-center"
                                        style={{ opacity: "0.8" }}
                                      >
                                        Selfie image{" "}
                                      </a>
                                    </div>
                                  </div>
                                  <div className="text-center mt-3">
                                    <h4 className="ct_fs_20 ct_fw_600 mb-1">
                                      {value?.name}, {value?.age}
                                    </h4>
                                    <p className=" ct_fw_500 mb-1 ct_fs_12">
                                      <i className="bi bi-geo-alt-fill me-1"></i>
                                      {value?.country}
                                    </p>
                                    <p className="ct_fw_500 mb-0 ct_fs_12">
                                      Upload at {pipTimeView(value?.update_at)},
                                      {pipViewDate2(value?.update_at)}
                                    </p>
                                  </div>
                                </div>
                              </figure>

                              <div>
                                <h4 className="ct_fs_24 mb-4 ct_fw_600">
                                  All Images
                                </h4>
                                <div className="ct_all_multiple_imgage">
                                  {
                                    value?.images != 0 ? (
                                      value?.images?.map((profiles) => (
                                        <img
                                          src={profiles ?? "/user_profile.png"}
                                          alt=""
                                        />
                                      ))
                                    ) : (
                                      <h4>No image found</h4>
                                    )}
                                </div>
                              </div>
                              {value?.is_verified == 0 &&
                                <div className="mt-4 d-flex align-items-center gap-3 justify-content-center">
                                  <button
                                    className="ct_orange_btn ct_btn_h_44  d-flex  align-items-center justify-content-center px-5 "
                                    onClick={handleVerifedUser}
                                  >
                                    {" "}
                                    Verify
                                  </button>
                                  <button
                                    className="ct_orange_btn ct_btn_h_44 ct_red_btn_123  d-flex  align-items-center justify-content-center px-5 "
                                    onClick={handleRejectUser}
                                  >
                                    {" "}
                                    Reject
                                  </button>
                                </div>
                              }
                            </>
                          ) : (
                            <NoRecord />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default VerificationRequest;
